import { AbstractReelProperties } from "@lib/titan2-slingo/dist/game/view/abstract/properties/AbstractReelProperties";
import { FontStyle } from "@lib/titan2-slingo/dist/game/view/abstract/style/FontStyle";
import { ControlConstants } from "@lib/titan2/dist/game/control/constant/ControlConstants";
import { SpineProperties } from "@lib/titan2/dist/game/control/properties/SpineProperties";
import { SpriteProperties } from "@lib/titan2/dist/game/control/properties/SpriteProperties";
import { TextFieldProperties } from "@lib/titan2/dist/game/control/properties/TextFieldProperties";
import { Point } from "pixi.js";
import { deepEquals } from "../../../utils/deepEquals";
import { GameSymbolUtil } from "../../../utils/GameSymbolUtil";
import { GameFontStyle } from "../style/GameFontStyle";
import { GameStyle } from "../style/GameStyle";
import { GameReelWildParticlesConfigFactory } from "./GameReelWildParticleEmitterConfig";
/**
* Game-specific properties for a reel.
*/
export class GameReelProperties extends AbstractReelProperties {
    constructor() {
        super();
        this.size = new Point(180, 174);
        this.winLineBorderDistance = 105;
        this.symbolIDToStaticMap = new Map();
        this.symbolProperties = new TextFieldProperties(FontStyle.REEL_SYMBOL, new Point(3, -87), null, ControlConstants.CENTER, ControlConstants.CENTER, new Point(180, 180));
        this.symbolHighlightProperties = new TextFieldProperties(GameFontStyle.REEL_SYMBOL_HIGHLIGHT, new Point(3, -87), null, ControlConstants.CENTER, ControlConstants.CENTER, new Point(180, 180));
        this.symbolAnimationSpineProperties = new SpineProperties(GameStyle.REEL_SYMBOL_ANIMATION, GameStyle.MODULE);
        this.transitionStagger = 50;
        this.particleEmitter = GameReelWildParticlesConfigFactory.createNew(new Point(-88, -88), 176, 176);
        this.suspenseAnim = "tension";
        this.suspenseAnimationProperties = new SpineProperties(GameStyle.REEL_SUSPENSE_ANIMATION, GameStyle.MODULE);
        this.suspenseAnimationProperties.defaultAnimation = this.suspenseAnim;
        // Add the non-number symbols and their static mappings.
        this.symbolIDToStaticMap.set(GameStyle.JOKER, new SpriteProperties(GameStyle.REEL_SYMBOL_WILD, GameStyle.MODULE, null, null, new Point(0.5, 0.5)));
        this.symbolIDToStaticMap.set(GameStyle.SUPER_JOKER, new SpriteProperties(GameStyle.REEL_SYMBOL_SUPER_WILD, GameStyle.MODULE, null, null, new Point(0.5, 0.5)));
        this.symbolIDToStaticMap.set(GameStyle.FREE_SPIN, new SpriteProperties(GameStyle.REEL_SYMBOL_FREE_SPIN, GameStyle.MODULE, null, null, new Point(0.5, 0.5)));
        this.symbolIDToStaticMap.set(GameStyle.DEVIL, new SpriteProperties(GameStyle.REEL_SYMBOL_BLOCKER, GameStyle.MODULE, null, null, new Point(0.5, 0.5)));
        this.reelSetsStandard = Array.from({ length: GameSymbolUtil.SYMBOL_COLUMNS }, () => [GameStyle.JOKER, GameStyle.SUPER_JOKER, GameStyle.FREE_SPIN]);
        this.reelSetsPurchase = Array.from({ length: GameSymbolUtil.SYMBOL_COLUMNS }, () => [GameStyle.JOKER, GameStyle.SUPER_JOKER]);
        // Add the number symbols and their static mappings.
        GameSymbolUtil.forEachNumber((num, column, variant) => {
            const id = num.toString();
            const properties = new SpriteProperties(`${GameStyle.REEL_SYMBOL}${variant + 1}`, GameStyle.MODULE, null, null, new Point(0.5, 0.5));
            this.symbolIDToStaticMap.set(id, properties);
            this.reelSetsStandard[column].push(id);
            this.reelSetsPurchase[column].push(id);
        });
    }
    equals(other) {
        return deepEquals(other, this);
    }
}
//# sourceMappingURL=GameReelProperties.js.map